exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".st1[data-v-5b3c2800]{opacity:.18;enable-background:new}.st2[data-v-5b3c2800]{opacity:.11;enable-background:new}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5b3c2800","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shared/BodyArkidian.vue
// module id = 376
// module chunks = 0